import * as React from 'react';
import { useState } from 'react';
import { ComboBox } from '@progress/kendo-react-dropdowns';
export const DropDownCell = (props, data, onMappedTypeChange) => {

    //console.log('DropDownCell', props, data);

    const localizedData = data;

    const {
        dataItem
    } = props;

    // What field is this applied, like: mappedType
    const field = props.field || '';
    // What's the value of this field
    const dataValue = dataItem[field] === null ? '' : dataItem[field];
    // Set iniial selected value, plus a callback
    const [selected, setSelected] = useState(localizedData.find(c => c.name === dataValue));

    //// Set default value, needs to match the data array format, in this case - name: "value"
    //const defaultItem =
    //{
    //    name: "Select ..."
    //};

    const handleChange = e => {
        if (props.onChange) {
            if (e.value) {
                // Update selected in datagrid
                setSelected(e.value);

                // Update props value
                props.dataItem.mappedType = e.value.name;
                props.dataItem.effectiveType = e.value.name;
                props.dataItem.isMapped = true;
                props.dataItem.isBoundToSchedule = true;

                // Pass update props to parent
                onMappedTypeChange({ eventType: 'map', dataItem: { name: props.dataItem.name, mappedType: e.value.name } });
            } else {
                // Update props value
                props.dataItem.mappedType = null;
                props.dataItem.effectiveType = null;
                props.dataItem.isMapped = false;
                props.dataItem.isBoundToSchedule = props.dataItem.isBoundToDefaultSchedule;

                // Pass update props to parent
                onMappedTypeChange({ eventType: 'unmap', dataItem: { name: props.dataItem.name, mappedType: null } });
            }
        }
    };


    return <td> 
        <ComboBox
            style={{ width: "100%" }}
            onChange={handleChange}
            value={selected}
            data={localizedData}
            textField="name"
        />
    </td>;
};